import {
  AddressForm as AddressFormQnr,
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '@getpopsure/qnr-framework';
import { useSafeTranslation } from 'shared/i18n';

interface Address {
  street?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

export const AddressForm = <Questionnaire extends QuestionnaireQuestions>({
  value,
  ...rest
}: QuestionnaireFormProps<Questionnaire>) => {
  const { t } = useSafeTranslation();

  return (
    <AddressFormQnr
      {...rest}
      value={value as Partial<Address> | undefined}
      placeholders={{
        manualAddressEntry: t(
          'qnr.forms.address.placeholders.manualAddressEntry',
          'Search for address'
        ),
        street: t('qnr.forms.address.placeholders.street', 'Street'),
        houseNumber: t(
          'qnr.forms.address.placeholders.houseNumber',
          'House Number'
        ),
        additionalInformation: t(
          'qnr.forms.address.placeholders.additionalInformation',
          'Additional information (C/O, apartment, ...)'
        ),
        postcode: t('qnr.forms.address.placeholders.postcode', 'Postcode'),
        city: t('qnr.forms.address.placeholders.city', 'City'),
      }}
      manualAddressEntryTexts={{
        preText: t('qnr.forms.address.manualAddressEntryTexts.preText', 'Or '),
        cta: t(
          'qnr.forms.address.manualAddressEntryTexts.cta',
          'enter address manually'
        ),
      }}
    />
  );
};
